var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#04AEEF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5337 9.51666L6.95866 18.0917C6.64269 18.4082 6.44299 18.8223 6.39199 19.2667L6.05033 22.2667C6.02806 22.4776 6.05054 22.6909 6.1163 22.8926C6.18206 23.0943 6.28963 23.2798 6.43198 23.4371C6.57432 23.5944 6.74825 23.7199 6.94239 23.8054C7.13653 23.8909 7.34653 23.9345 7.55866 23.9333H7.73366L10.7337 23.5917C11.1763 23.5405 11.5894 23.3441 11.9087 23.0333L20.4837 14.45L15.5337 9.51666Z",
    fill: "#04AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3837 8.79168L21.2087 6.61668C21.0267 6.43401 20.8105 6.28906 20.5724 6.19016C20.3343 6.09126 20.079 6.04034 19.8212 6.04034C19.5633 6.04034 19.308 6.09126 19.0699 6.19016C18.8318 6.28906 18.6156 6.43401 18.4337 6.61668L16.417 8.63335L21.367 13.5833L23.3837 11.5667C23.5663 11.3847 23.7113 11.1685 23.8102 10.9304C23.9091 10.6923 23.96 10.437 23.96 10.1792C23.96 9.92135 23.9091 9.66607 23.8102 9.42796C23.7113 9.18986 23.5663 8.97363 23.3837 8.79168Z",
    fill: "#04AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.aad93b00abacd4193c4e4cd57fff91e5.svg";
export { ForwardRef as ReactComponent };